import { ajv } from '@cibo/core/src/utils/ajv'
import type { JSONSchema7WithErrors } from '@cibo/core/src/types/JSONSchema7WithErrors'
import type { ErrorObject } from 'ajv'
import type { WarningEntry } from 'dynamic-uniforms'

export type { WarningEntry }

function collectErrors(ajvErrors: ErrorObject[]): Record<string, WarningEntry> {
  const errors: Record<string, WarningEntry> = {}
  for (const err of ajvErrors) {
    const path = (err.instancePath ?? '')
      .slice(1) // remove leading "/"
      .replace(/\//g, '.') // convert "/" separators to "."
    if (path) {
      errors[path] = {
        message: err.message || 'Warning',
        keyword: err.keyword,
      }
    }
  }
  return errors
}

export function createWarningsValidator(schema: JSONSchema7WithErrors) {
  const validate = ajv.compile(schema)
  return async (model: any): Promise<Record<string, WarningEntry>> => {
    try {
      await validate(model)
      // Sync schema: validate() returned false; errors are on validate.errors
      return validate.errors ? collectErrors(validate.errors) : {}
    } catch (err: any) {
      // Async schema ($async: true): AJV rejects with ValidationError on failure
      return err?.errors ? collectErrors(err.errors) : {}
    }
  }
}
